import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { globals } from 'src/app/globals';
import { ToastService } from '../services/toast.service';
import { userService } from '../services/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {

  login: any = {};
  instance: any = 1;
  state: any = 1;

  constructor(
    public userService: userService, 
    private router: Router,
    private toastService: ToastService,
    private http: HttpClient
  ) { }

  loginUser() {

    const header = new HttpHeaders()
      .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiFunctionName', 'login')

    const body = this.login;

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true && response.body.dataArray) {
            this.state = 2;
            this.login = response.body.dataArray;
            this.login.remainder = 900000;
            // count down from 30 minutes
            setInterval(() => {
              this.login.remainder = (this.login.remainder - 1000);
            }, 1000);
          }
          else {
            this.toastService.showToast({ header: 'Error', message: 'Username and password does not match our records' });
          }
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Username and password does not match our records' });
        }
      );
    
  }

  authenticateUser() {

    const header = new HttpHeaders()
    .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiToken', this.login.token)
      .set('apiFunctionName', 'checkCode')

    const body = this.login;

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true && response.body.response == 200) {
            this.userService.setData(this.login);
            // this.router.navigate(['/dashboard/home']);
            setTimeout(()=>{         
              if (window.location.hostname == 'aup.my-runway.co.uk') {
                window.location.href = 'https://aup.my-runway.co.uk/';
              } 
              else {                
                window.location.href = 'https://my-runway.co.uk/';
              }
            }, 500);
            this.state = 1;
            this.login = {};
            // check token every 15 minutes
            setInterval(() => {
              this.checkToken(response.body.dataArray);
            }, 900000);
          }
          else {
            this.toastService.showToast({ header: 'Error', message: 'Authentication code does not match our records' });
          }
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Authentication code does not match our records' });
        }
      );

  }

  forgot() {

    this.state = 3;

  }

  sendReset() {

    const header = new HttpHeaders()
      .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiFunctionName', 'sendReset')

    const body = this.login;

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true) {
            this.login.remainder = 900000;
            // count down from 30 minutes
            setInterval(() => {
              this.login.remainder = (this.login.remainder - 1000);
            }, 1000);
            this.state = 4;
          }
          else {
            this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong trying to reset your password' });
          }
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong trying to reset your password' });
        }
      );
    
  }

  checkReset() {

    const header = new HttpHeaders()
      .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiFunctionName', 'checkReset')

    const body = this.login;

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true) {
            this.login.remainder = '';
            this.state = 5;
          }
          else {
            this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong verifying your reset link' });
          }
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong verifying your reset link' });
        }
      );

  }

  resetPassword() {

    if (this.login.newPassword == this.login.newPasswordConfirm) {

      if (this.login.password.length >= 8) {

        const header = new HttpHeaders()
          .set('Content-Type', 'text/plain')

        const param = new HttpParams()
          .set('apiKey', globals.key)
          .set('apiFunctionName', 'resetPassword')

        const body = this.login;

        this.http
          .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
          .subscribe(
            (response: any) => {
              if (response.body.success == true) {
                this.login = {};
                this.state = 1;
                this.toastService.showToast({ header: 'Success', message: 'Hurah, Your password has been reset' });
              }
              else {
                this.toastService.showToast({ header: 'Error', message: 'Please check the password contains at least one number' });
              }
            },
            (error: any) => {
              this.toastService.showToast({ header: 'Error', message: 'Oops. Something went wrong. Please try again' });
            }
          );
      
      }
      else {

        this.toastService.showToast({ header: 'Error', message: 'Password must be at least eight characters' });

      }
    
    }
    else {

      this.toastService.showToast({ header: 'Error', message: 'Passwords do not match' });

    }
    
  }

  checkToken(x) {
    const header = new HttpHeaders()
      .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiToken', x.token)
      .set('apiFunctionName', 'checkToken')

    const body = {
      'uid' : x.id
    };

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          
        },
        (error: any) => {

        }
      );
  }

  ngOnInit() {
    if (window.location.hostname == 'aup.my-runway.co.uk') {
      this.instance = 2;
    }
  }

}